/** Page keyboard shortcuts (Full screen's F, double-click) and when they stand down. */

/** Typing in a field (Watch + putt's link box) or working inside a dialog is
 *  never a page shortcut (peer review F04). */
export function isEditableTarget(target: EventTarget | null): boolean {
  const el = target as (HTMLElement & { isContentEditable?: boolean }) | null;
  if (!el || typeof el.tagName !== 'string') return false;
  const tag = el.tagName.toUpperCase();
  if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || el.isContentEditable) return true;
  return typeof el.closest === 'function' && el.closest('[aria-modal="true"]') != null;
}
